<ng-template #content let-modal>
  <div class="modal-header" style="justify-content: space-between">
    <h4 class="modal-title" id="help-modal-title">{{ title ? title : 'Help' }}</h4>
    <i class="fa fa-times" (click)="modal.dismiss('Cross click')"></i>
  </div>
  <div class="modal-body">
    <p [innerHTML]="helpText"></p>
  </div>
  <div class="modal-footer">
  </div>
</ng-template>
<i *ngIf="loaded && !showText" (click)="open(content, $event)" ngbTooltip="Click for assistance" class="fa fa-question-circle"></i>
<p *ngIf="loaded && showText" [innerHTML]="helpText"></p>
